var _defs, _g, _g2, _clipPath, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigned({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    height: 10,
    id: "screenshot-cfa24981-2c3f-80dd-8008-77359a33d407",
    viewBox: "0 0 10 10",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-cfa24981-2c3f-80dd-8008-77359a33d407"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-cfa24981-2c3f-80dd-8008-77359a33d407-render-1",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-cfa24981-2c3f-80dd-8008-77359a33d407-render-1)",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-cfa24981-2c3f-80dd-8008-77359a33d407"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-cfa24981-2c3f-80dd-8008-77359a33d408",
    style: {
      opacity: 1
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-cfa24981-2c3f-80dd-8008-77359a33d408"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.000000238418579,
    cy: 5,
    rx: 3.750000238418579,
    ry: 3.75,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-282142f7-9d0a-8048-8008-7735b9fa47b2-cfa24981-2c3f-80dd-8008-77359a33d408",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-2-cfa24981-2c3f-80dd-8008-77359a33d408-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-2-cfa24981-2c3f-80dd-8008-77359a33d408-0"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.000000238418579,
    cy: 5,
    rx: 3.750000238418579,
    ry: 3.75,
    id: "stroke-shape-render-2-cfa24981-2c3f-80dd-8008-77359a33d408-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(55, 101, 219)",
      strokeOpacity: 1
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-2-cfa24981-2c3f-80dd-8008-77359a33d408-0",
    clipPath: "url('#inner-stroke-render-2-cfa24981-2c3f-80dd-8008-77359a33d408-0')"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigned);
export default __webpack_public_path__ + "static/media/signed.6471fdb6281d4fbad441942fceb54b46.svg";
export { ForwardRef as ReactComponent };